export const JSUtility = {
    replaceAllSpaces: (str, target) => str.replace(/\s/g, target),

    capitalizeFistLetter: function (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
    },

    capitalizeWordsInSentence: function (sentence) {
        return sentence.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())
    },

    isObject: function (item) {
        return typeof item === 'object' && !Array.isArray(item) && item !== null
    },
    /**
     * @param {Callback} transformFunction -> Function to run on each element.
     * @param {Array} array -> List of items to transform.
     * @returns Returns a new array of items, each one transformed according to the given transformFunction.
     */
    map: function (transformFunction, array) {
        return array.reduce((newArray, item) => {
            newArray.push(transformFunction(item))
            return newArray
        }, [])
    },
    /**
     * @param {Callback} predicate -> Function that returns true or false.
     * @param {Array} array -> List of items to filter.
     * @returns Returns a new array. If predicate returns true, that item is added to the new array. Otherwise that item is excluded from the new array.
     */
    filter: function (predicate, array) {
        return array.reduce((newArray, item) => {
            if (predicate(item) === true) {
                newArray.push(item)
            }
            return newArray
        }, [])
    },
    /**
     * @param {Callback} predicate -> Function that returns true or false.
     * @param {Array} array -> List of items to filter.
     * @returns If predicate returns false, that item is added to the new array. Otherwise that item is excluded from the new array.
     */
    reject: function (predicate, array) {
        return array.reduce((newArray, item) => {
            if (predicate(item) === false) {
                newArray.push(item)
            }
            return newArray
        }, [])
    },
    /**
     * @param {String} key -> Key name to pluck from the object
     * @param {Array} array -> List of items.
     * @returns Plucks the given key off of each item in the array. Returns a new array
     */
    pluck: function (key, array) {
        return array.reduce((values, current) => {
            values.push(current[key])
            return values
        }, [])
    },
    /**
     * @param {String} key -> Key name to pluck from the object
     * @param {Array} array -> List of items.
     * @returns "Partitions" or splits an array into two based on the predicate. If predicate returns true, the item goes into list 1. Otherwise the item goes into list 2.
     */
    partition: function (predicate, array) {
        return array.reduce(
            (result, item) => {
                const [list1, list2] = result

                if (predicate(item) === true) {
                    list1.push(item)
                } else {
                    list2.push(item)
                }

                return result
            },
            [[], []]
        )
    },
    /**
     * @param {*} string '1.45oz'
     * @returns string after removing alphabets '1.45'
     */
    extractOnlyNumeric: string => string.replace(/[a-zA-Z]/g, ''),
    /**
     * @param {*} string '1.45oz'
     * @returns string after removing numbers and periods 'oz'
     */
    extractOnlyAlphabets: string => string.replace(/[0-9?.]/g, ''),

    intersect: (a, b) => {
        const setA = new Set(a)
        const setB = new Set(b)
        const intersection = new Set([...setA].filter(x => setB.has(x)))
        return Array.from(intersection)
    },

    disjoint: (a, b) => {
        const setA = new Set(a)
        const setB = new Set(b)
        const disjoint = new Set([...setA].filter(x => !setB.has(x)))
        return Array.from(disjoint)
    },

    pickKey: function (key, array) {
        return array.reduce((acc, curr) => {
            if (typeof curr === 'object' && !Array.isArray(curr) && curr !== null) {
                if (curr[key]) {
                    acc[curr[key]] = 1
                    return acc
                } else {
                    return acc
                }
            }
            return acc
        }, {})
    },
}
